import { blobInstance, downloader, instance } from '../helpers'
import { AxiosResponse } from 'axios'

export class RestService<T = any> {
    url: string
    instance = instance

    constructor(url?: string) {
        if (url) {
            this.url = url.endsWith('/') ? url : `${url}/`
        }
    }

    makeGetRequest<R = T>(search_object?: Record<string, any>): Promise<AxiosResponse<R>> {
        return this.instance.get<R>(this.url, { params: search_object })
    }

    makeSearchRequest<R = T>(value: string): Promise<AxiosResponse<R>> {
        return this.instance.get<R>(`${this.url}?search=${value}`)
    }

    makeFetchRequest<R = T>(id: string | number): Promise<AxiosResponse<R>> {
        return this.instance.get<R>(`${this.url}${id}`)
    }

    makePostRequest<R = T>(payload: any): Promise<AxiosResponse<R>> {
        return this.instance.post<R>(this.url, payload)
    }

    makePutRequest<R = T>(payload: any): Promise<AxiosResponse<R>> {
        return this.instance.put<R>(this.url, payload)
    }

    makeDeleteRequest<R = T>(payload?: { url: string }): Promise<AxiosResponse<R>> {
        return payload
            ? this.instance.delete<R>(payload.url)
            : this.instance.delete<R>(this.url)
    }

    makePatchRequest<R = T>(payload: any): Promise<AxiosResponse<R>> {
        return this.instance.patch<R>(this.url, payload)
    }

    download(url: string, filename: string, mime: string = 'text/csv'): void {
        blobInstance.get(url, { responseType: 'blob' }).then((res) => {
            downloader(res.data, filename, mime)
        })
    }

    upload<R = T>(url: string, data: FormData): Promise<AxiosResponse<R>> {
        return this.instance.post<R>(url, data, {
            headers: {
                'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW',
            },
        })
    }

    upload2<R = T>(url: string, data: any): Promise<AxiosResponse<R>> {
        return this.instance.post<R>(url, data)
    }

    static call_url_action<R = any>(
        url: string,
        http_method: string,
        payload?: any
    ): Promise<AxiosResponse<R>> {
        const method = http_method.toUpperCase()
        if (method === 'GET') {
            return instance.get<R>(url, { params: payload })
        } else if (method === 'PUT') {
            return instance.put<R>(url, payload)
        } else {
            return instance.post<R>(url, payload)
        }
    }

    get_change_log<R = any>(): Promise<AxiosResponse<R>> {
        return RestService.call_url_action<R>(`${this.url}change_logs/`, 'GET')
    }
}
